import { render } from "./MainBody.vue?vue&type=template&id=5fc380d6&scoped=true"
import script from "./MainBody.vue?vue&type=script&lang=js"
export * from "./MainBody.vue?vue&type=script&lang=js"

import "./MainBody.vue?vue&type=style&index=0&id=5fc380d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc380d6"]])

export default __exports__